module.exports = __webpack_public_path__ + "img/bn.c9854b6a.svg";